import { FadeIn } from "@/components/FadeIn";
import { SectionHeading, GoldDivider } from "@/components/SectionHeading";
import { Separator } from "@/components/ui/separator";

export default function Datenschutz() {
    return (
        <div className="min-h-screen">
            {/* Hero Section */}
            <section className="relative py-20 md:py-28 bg-gradient-to-b from-background to-muted/30">
                <div className="container mx-auto px-4 max-w-4xl">
                    <FadeIn>
                        <SectionHeading
                            title="Datenschutzerklärung"
                            subtitle="Informationen zum Schutz Ihrer personenbezogenen Daten"
                        />
                        <GoldDivider />
                    </FadeIn>
                </div>
            </section>

            {/* Content */}
            <section className="py-16 md:py-24">
                <div className="container mx-auto px-4 max-w-3xl space-y-12">
                    {/* 1. Datenschutz auf einen Blick */}
                    <FadeIn>
                        <div className="space-y-3">
                            <h2 className="font-serif text-2xl font-semibold text-foreground">
                                1. Datenschutz auf einen Blick
                            </h2>
                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Allgemeine Hinweise
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Die folgenden Hinweise geben einen einfachen Überblick
                                darüber, was mit Ihren personenbezogenen Daten passiert, wenn
                                Sie diese Website besuchen. Personenbezogene Daten sind alle
                                Daten, mit denen Sie persönlich identifiziert werden können.
                                Ausführliche Informationen zum Thema Datenschutz entnehmen
                                Sie unserer unter diesem Text aufgeführten
                                Datenschutzerklärung.
                            </p>
                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Datenerfassung auf dieser Website
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                <strong className="text-foreground">
                                    Wer ist verantwortlich für die Datenerfassung auf dieser
                                    Website?
                                </strong>
                                <br />
                                Die Datenverarbeitung auf dieser Website erfolgt durch den
                                Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt
                                „Hinweis zur verantwortlichen Stelle" in dieser
                                Datenschutzerklärung entnehmen.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                <strong className="text-foreground">
                                    Wie erfassen wir Ihre Daten?
                                </strong>
                                <br />
                                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns
                                diese mitteilen. Hierbei kann es sich z.&nbsp;B. um Daten
                                handeln, die Sie in unser Kontaktformular eingeben (Name,
                                E-Mail-Adresse, Telefonnummer, Betreff und Nachricht).
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Andere Daten werden automatisch oder nach Ihrer Einwilligung
                                beim Besuch der Website durch unsere IT-Systeme erfasst. Das
                                sind vor allem technische Daten (z.&nbsp;B. Internetbrowser,
                                Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung
                                dieser Daten erfolgt automatisch, sobald Sie diese Website
                                betreten.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                <strong className="text-foreground">
                                    Wofür nutzen wir Ihre Daten?
                                </strong>
                                <br />
                                Ein Teil der Daten wird erhoben, um eine fehlerfreie
                                Bereitstellung der Website zu gewährleisten. Andere Daten
                                können zur Analyse Ihres Nutzerverhaltens verwendet werden.
                                Wenn Sie uns über das Kontaktformular kontaktieren, werden
                                Ihre Angaben zur Bearbeitung Ihrer Anfrage verwendet.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                <strong className="text-foreground">
                                    Welche Rechte haben Sie bezüglich Ihrer Daten?
                                </strong>
                                <br />
                                Sie haben jederzeit das Recht, unentgeltlich Auskunft über
                                Herkunft, Empfänger und Zweck Ihrer gespeicherten
                                personenbezogenen Daten zu erhalten. Sie haben außerdem ein
                                Recht, die Berichtigung oder Löschung dieser Daten zu
                                verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung
                                erteilt haben, können Sie diese Einwilligung jederzeit für die
                                Zukunft widerrufen. Außerdem haben Sie das Recht, unter
                                bestimmten Umständen die Einschränkung der Verarbeitung Ihrer
                                personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen
                                ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können
                                Sie sich jederzeit an uns wenden.
                            </p>
                        </div>
                    </FadeIn>

                    <Separator />

                    {/* 2. Hosting */}
                    <FadeIn>
                        <div className="space-y-3">
                            <h2 className="font-serif text-2xl font-semibold text-foreground">
                                2. Hosting
                            </h2>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Wir hosten die Inhalte unserer Website bei einem externen
                                Dienstleister (Hoster). Die personenbezogenen Daten, die auf
                                dieser Website erfasst werden, werden auf den Servern des
                                Hosters gespeichert. Hierbei kann es sich v.&nbsp;a. um
                                IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten,
                                Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und
                                sonstige Daten, die über eine Website generiert werden,
                                handeln.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Der Einsatz des Hosters erfolgt zum Zwecke der
                                Vertragserfüllung gegenüber unseren potenziellen und
                                bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im
                                Interesse einer sicheren, schnellen und effizienten
                                Bereitstellung unseres Online-Angebots durch einen
                                professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
                            </p>
                        </div>
                    </FadeIn>

                    <Separator />

                    {/* 3. Allgemeine Hinweise und Pflichtinformationen */}
                    <FadeIn>
                        <div className="space-y-3">
                            <h2 className="font-serif text-2xl font-semibold text-foreground">
                                3. Allgemeine Hinweise und Pflichtinformationen
                            </h2>

                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Datenschutz
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Die Betreiber dieser Seiten nehmen den Schutz Ihrer
                                persönlichen Daten sehr ernst. Wir behandeln Ihre
                                personenbezogenen Daten vertraulich und entsprechend den
                                gesetzlichen Datenschutzvorschriften sowie dieser
                                Datenschutzerklärung.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Wenn Sie diese Website benutzen, werden verschiedene
                                personenbezogene Daten erhoben. Personenbezogene Daten sind
                                Daten, mit denen Sie persönlich identifiziert werden können.
                                Die vorliegende Datenschutzerklärung erläutert, welche Daten
                                wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie
                                und zu welchem Zweck das geschieht.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Wir weisen darauf hin, dass die Datenübertragung im Internet
                                (z.&nbsp;B. bei der Kommunikation per E-Mail)
                                Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der
                                Daten vor dem Zugriff durch Dritte ist nicht möglich.
                            </p>

                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Hinweis zur verantwortlichen Stelle
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Die verantwortliche Stelle für die Datenverarbeitung auf
                                dieser Website ist:
                            </p>
                            <p className="font-sans text-foreground leading-relaxed">
                                Ruberto Steuerberatung
                                <br />
                                Mario Ruberto
                                <br />
                                Neuhauser Str. 27
                                <br />
                                80331 München
                            </p>
                            <p className="font-sans text-foreground leading-relaxed">
                                Telefon: 089 401 929 200
                                <br />
                                E-Mail:{" "}
                                <a
                                    href="mailto:info@steuerkanzlei-ruberto.de"
                                    className="text-primary hover:underline"
                                >
                                    info@steuerkanzlei-ruberto.de
                                </a>
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Verantwortliche Stelle ist die natürliche oder juristische
                                Person, die allein oder gemeinsam mit anderen über die Zwecke
                                und Mittel der Verarbeitung von personenbezogenen Daten
                                (z.&nbsp;B. Namen, E-Mail-Adressen o.&nbsp;Ä.) entscheidet.
                            </p>

                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Speicherdauer
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Soweit innerhalb dieser Datenschutzerklärung keine speziellere
                                Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen
                                Daten bei uns, bis der Zweck für die Datenverarbeitung
                                entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend
                                machen oder eine Einwilligung zur Datenverarbeitung widerrufen,
                                werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich
                                zulässigen Gründe für die Speicherung Ihrer personenbezogenen
                                Daten haben (z.&nbsp;B. steuer- oder handelsrechtliche
                                Aufbewahrungsfristen); im letztgenannten Fall erfolgt die
                                Löschung nach Fortfall dieser Gründe.
                            </p>

                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Allgemeine Hinweise zu den Rechtsgrundlagen der
                                Datenverarbeitung auf dieser Website
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Sofern Sie in die Datenverarbeitung eingewilligt haben,
                                verarbeiten wir Ihre personenbezogenen Daten auf Grundlage von
                                Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO,
                                sofern besondere Datenkategorien nach Art. 9 Abs. 1 DSGVO
                                verarbeitet werden. Im Falle einer ausdrücklichen Einwilligung
                                in die Übertragung personenbezogener Daten in Drittstaaten
                                erfolgt die Datenverarbeitung außerdem auf Grundlage von Art.
                                49 Abs. 1 lit. a DSGVO. Sofern die Datenverarbeitung zur
                                Vertragserfüllung oder zur Durchführung vorvertraglicher
                                Maßnahmen erforderlich ist, verarbeiten wir Ihre Daten auf
                                Grundlage von Art. 6 Abs. 1 lit. b DSGVO. Des Weiteren
                                verarbeiten wir Ihre Daten, sofern diese zur Erfüllung einer
                                rechtlichen Verpflichtung erforderlich sind, auf Grundlage von
                                Art. 6 Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann ferner
                                auf Grundlage unseres berechtigten Interesses nach Art. 6 Abs.
                                1 lit. f DSGVO erfolgen.
                            </p>

                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Widerruf Ihrer Einwilligung zur Datenverarbeitung
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Viele Datenverarbeitungsvorgänge sind nur mit Ihrer
                                ausdrücklichen Einwilligung möglich. Sie können eine bereits
                                erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit
                                der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom
                                Widerruf unberührt.
                            </p>

                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen
                                sowie gegen Direktwerbung (Art. 21 DSGVO)
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1
                                LIT. E ODER F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT,
                                AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN,
                                GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN
                                WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN AUF DIESE
                                BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE
                                RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN
                                SIE DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH
                                EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN
                                NICHT MEHR VERARBEITEN, ES SEI DENN, WIR KÖNNEN ZWINGENDE
                                SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG NACHWEISEN, DIE IHRE
                                INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN ODER DIE
                                VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG ODER
                                VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21
                                ABS. 1 DSGVO).
                            </p>

                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Beschwerderecht bei der zuständigen Aufsichtsbehörde
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Im Falle von Verstößen gegen die DSGVO steht den Betroffenen
                                ein Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in
                                dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres
                                Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu. Das
                                Beschwerderecht besteht unbeschadet anderweitiger
                                verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
                            </p>

                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Recht auf Datenübertragbarkeit
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Sie haben das Recht, Daten, die wir auf Grundlage Ihrer
                                Einwilligung oder in Erfüllung eines Vertrags automatisiert
                                verarbeiten, an sich oder an einen Dritten in einem gängigen,
                                maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die
                                direkte Übertragung der Daten an einen anderen
                                Verantwortlichen verlangen, erfolgt dies nur, soweit es
                                technisch machbar ist.
                            </p>

                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Auskunft, Löschung und Berichtigung
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen
                                jederzeit das Recht auf unentgeltliche Auskunft über Ihre
                                gespeicherten personenbezogenen Daten, deren Herkunft und
                                Empfänger und den Zweck der Datenverarbeitung und ggf. ein
                                Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie
                                zu weiteren Fragen zum Thema personenbezogene Daten können Sie
                                sich jederzeit an uns wenden.
                            </p>

                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Recht auf Einschränkung der Verarbeitung
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer
                                personenbezogenen Daten zu verlangen. Hierzu können Sie sich
                                jederzeit an uns wenden. Das Recht auf Einschränkung der
                                Verarbeitung besteht in folgenden Fällen:
                            </p>
                            <ul className="font-sans text-muted-foreground leading-relaxed list-disc list-inside space-y-1 pl-4">
                                <li>
                                    Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten
                                    personenbezogenen Daten bestreiten, benötigen wir in der
                                    Regel Zeit, um dies zu überprüfen. Für die Dauer der Prüfung
                                    haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer
                                    personenbezogenen Daten zu verlangen.
                                </li>
                                <li>
                                    Wenn die Verarbeitung Ihrer personenbezogenen Daten
                                    unrechtmäßig geschah/geschieht, können Sie statt der Löschung
                                    die Einschränkung der Datenverarbeitung verlangen.
                                </li>
                                <li>
                                    Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen,
                                    Sie sie jedoch zur Ausübung, Verteidigung oder
                                    Geltendmachung von Rechtsansprüchen benötigen, haben Sie das
                                    Recht, statt der Löschung die Einschränkung der Verarbeitung
                                    Ihrer personenbezogenen Daten zu verlangen.
                                </li>
                                <li>
                                    Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO
                                    eingelegt haben, muss eine Abwägung zwischen Ihren und
                                    unseren Interessen vorgenommen werden. Solange noch nicht
                                    feststeht, wessen Interessen überwiegen, haben Sie das Recht,
                                    die Einschränkung der Verarbeitung Ihrer personenbezogenen
                                    Daten zu verlangen.
                                </li>
                            </ul>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten
                                eingeschränkt haben, dürfen diese Daten – von ihrer Speicherung
                                abgesehen – nur mit Ihrer Einwilligung oder zur
                                Geltendmachung, Ausübung oder Verteidigung von
                                Rechtsansprüchen oder zum Schutz der Rechte einer anderen
                                natürlichen oder juristischen Person oder aus Gründen eines
                                wichtigen öffentlichen Interesses der Europäischen Union oder
                                eines Mitgliedstaats verarbeitet werden.
                            </p>

                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                SSL- bzw. TLS-Verschlüsselung
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
                                Übertragung vertraulicher Inhalte, wie zum Beispiel Anfragen,
                                die Sie an uns als Seitenbetreiber senden, eine SSL- bzw.
                                TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen
                                Sie daran, dass die Adresszeile des Browsers von „http://" auf
                                „https://" wechselt und an dem Schloss-Symbol in Ihrer
                                Browserzeile.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können
                                die Daten, die Sie an uns übermitteln, nicht von Dritten
                                mitgelesen werden.
                            </p>
                        </div>
                    </FadeIn>

                    <Separator />

                    {/* 4. Datenerfassung auf dieser Website */}
                    <FadeIn>
                        <div className="space-y-3">
                            <h2 className="font-serif text-2xl font-semibold text-foreground">
                                4. Datenerfassung auf dieser Website
                            </h2>

                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Kontaktformular
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen,
                                werden Ihre Angaben aus dem Anfrageformular inklusive der von
                                Ihnen dort angegebenen Kontaktdaten (Name, E-Mail-Adresse,
                                Telefonnummer, Betreff und Nachricht) zwecks Bearbeitung der
                                Anfrage und für den Fall von Anschlussfragen bei uns
                                gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung
                                weiter.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6
                                Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung
                                eines Vertrags zusammenhängt oder zur Durchführung
                                vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen
                                Fällen beruht die Verarbeitung auf unserem berechtigten
                                Interesse an der effektiven Bearbeitung der an uns gerichteten
                                Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
                                Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese
                                abgefragt wurde.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben
                                bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung
                                zur Speicherung widerrufen oder der Zweck für die
                                Datenspeicherung entfällt (z.&nbsp;B. nach abgeschlossener
                                Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen
                                – insbesondere Aufbewahrungsfristen – bleiben unberührt.
                            </p>

                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Anfrage per E-Mail, Telefon oder Telefax
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren,
                                wird Ihre Anfrage inklusive aller daraus hervorgehenden
                                personenbezogenen Daten (Name, Anfrage) zum Zwecke der
                                Bearbeitung Ihres Anliegens bei uns gespeichert und
                                verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung
                                weiter.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6
                                Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung
                                eines Vertrags zusammenhängt oder zur Durchführung
                                vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen
                                Fällen beruht die Verarbeitung auf unserem berechtigten
                                Interesse an der effektiven Bearbeitung der an uns gerichteten
                                Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
                                Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese
                                abgefragt wurde.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Die von Ihnen an uns per Kontaktanfrage übersandten Daten
                                verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre
                                Einwilligung zur Speicherung widerrufen oder der Zweck für die
                                Datenspeicherung entfällt (z.&nbsp;B. nach abgeschlossener
                                Bearbeitung Ihres Anliegens). Zwingende gesetzliche
                                Bestimmungen – insbesondere gesetzliche Aufbewahrungsfristen –
                                bleiben unberührt.
                            </p>
                        </div>
                    </FadeIn>

                    <Separator />

                    {/* 5. Plugins und Tools */}
                    <FadeIn>
                        <div className="space-y-3">
                            <h2 className="font-serif text-2xl font-semibold text-foreground">
                                5. Plugins und Tools
                            </h2>

                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Google Maps
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Diese Seite nutzt den Kartendienst Google Maps. Anbieter ist
                                die Google Ireland Limited („Google"), Gordon House, Barrow
                                Street, Dublin 4, Irland.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Zur Nutzung der Funktionen von Google Maps ist es notwendig,
                                Ihre IP-Adresse zu speichern. Diese Informationen werden in der
                                Regel an einen Server von Google in den USA übertragen und dort
                                gespeichert. Der Anbieter dieser Seite hat keinen Einfluss auf
                                diese Datenübertragung. Wenn Google Maps aktiviert ist, kann
                                Google zum Zwecke der einheitlichen Darstellung der Schriftarten
                                Google Fonts verwenden. Beim Aufruf von Google Maps lädt Ihr
                                Browser die benötigten Web Fonts in Ihren Browsercache, um
                                Texte und Schriftarten korrekt anzuzeigen.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Die Nutzung von Google Maps erfolgt im Interesse einer
                                ansprechenden Darstellung unseres Online-Angebots und an einer
                                leichten Auffindbarkeit der von uns auf der Website angegebenen
                                Orte. Dies stellt ein berechtigtes Interesse im Sinne von Art.
                                6 Abs. 1 lit. f DSGVO dar. Sofern eine entsprechende
                                Einwilligung abgefragt wurde, erfolgt die Verarbeitung
                                ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO;
                                die Einwilligung ist jederzeit widerrufbar.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Die Datenübertragung in die USA wird auf die
                                Standardvertragsklauseln der EU-Kommission gestützt. Details
                                finden Sie hier:{" "}
                                <a
                                    href="https://privacy.google.com/businesses/gdprcontrollerterms/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-primary hover:underline break-all"
                                >
                                    https://privacy.google.com/businesses/gdprcontrollerterms/
                                </a>{" "}
                                und{" "}
                                <a
                                    href="https://privacy.google.com/businesses/gdprcontrollerterms/sccs/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-primary hover:underline break-all"
                                >
                                    https://privacy.google.com/businesses/gdprcontrollerterms/sccs/
                                </a>
                                .
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Mehr Informationen zum Umgang mit Nutzerdaten finden Sie in der
                                Datenschutzerklärung von Google:{" "}
                                <a
                                    href="https://policies.google.com/privacy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-primary hover:underline break-all"
                                >
                                    https://policies.google.com/privacy
                                </a>
                                .
                            </p>

                            <h3 className="font-serif text-lg font-semibold text-foreground pt-2">
                                Google Fonts (lokal eingebunden)
                            </h3>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Diese Seite nutzt zur einheitlichen Darstellung von
                                Schriftarten so genannte Google Fonts. Die Google Fonts sind
                                lokal auf unserem Server installiert. Eine Verbindung zu
                                Servern von Google findet dabei nicht statt.
                            </p>
                            <p className="font-sans text-muted-foreground leading-relaxed">
                                Weitere Informationen zu Google Fonts finden Sie unter{" "}
                                <a
                                    href="https://developers.google.com/fonts/faq"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-primary hover:underline break-all"
                                >
                                    https://developers.google.com/fonts/faq
                                </a>{" "}
                                und in der Datenschutzerklärung von Google:{" "}
                                <a
                                    href="https://policies.google.com/privacy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-primary hover:underline break-all"
                                >
                                    https://policies.google.com/privacy
                                </a>
                                .
                            </p>
                        </div>
                    </FadeIn>
                </div>
            </section>
        </div>
    );
}
